export function applyLeagueChanges(league, updatedLeague) {
    league.id = updatedLeague.id;
    league.name = updatedLeague.name;
    league.sportId = updatedLeague.sportId;
    league.sportName = updatedLeague.sportName;
    league.regionId = updatedLeague.regionId;
    league.regionCode = updatedLeague.regionCode;
    league.defaultOrder = updatedLeague.defaultOrder;
    league.isTopLeague = updatedLeague.isTopLeague;
    league.masterLeagueId = updatedLeague.masterLeagueId;
    league.liveFixturesTotalCount = updatedLeague.liveFixturesTotalCount;
    league.fixturesTotalCount = updatedLeague.fixturesTotalCount;
    league.fixturesCount = updatedLeague.fixturesCount;
    league.outrightsTotalCount = updatedLeague.outrightsTotalCount;
    league.liveOutrightsTotalCount = updatedLeague.liveOutrightsTotalCount;
    league.entityType = updatedLeague.entityType;
    league.tags = updatedLeague.tags;
    //league.streamBlockedCountryCodes = updatedLeague.streamBlockedCountryCodes
    league.metadata = updatedLeague.metadata;
}
//# sourceMappingURL=applyLeagueChanges.js.map